import React, { useEffect, useMemo, useState } from 'react'
import { Spin } from 'antd'

import {
  getEnvironmentVariable,
  showErrorNotification,
} from '../../../core/helpers'

import { Page } from '../../../common/components/sections'
import {
  StyledPageContent,
  StyledPageTitle,
} from '../../../common/components/styled'
import { APP_NAME, APP_ROUTES } from '../../../common/constants'
import { useDocumentTitle } from '../../../common/hooks'
import { aiHttpService } from '../../../common/services'

import { ProductInfoCards } from '../sections'

const currentProductInfo = {
  type: APP_NAME,
  version: parseInt(getEnvironmentVariable('REACT_APP_VERSION'), 10),
  accuracy: null,
  deployedAt: null,
}

const AboutPage = () => {
  const title = APP_ROUTES.MISC.children.ABOUT.label
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useDocumentTitle(title)

  useEffect(() => {
    const getInfo = async () => {
      try {
        const response = await aiHttpService.get('/ml/info')
        setData(response)
      } catch ({ name, message }) {
        showErrorNotification({ title: name, description: message })
      }
      setIsLoading(false)
    }

    getInfo()
  }, [])

  const dataSource = useMemo(() => [currentProductInfo, ...data], [data])

  return (
    <Page>
      <StyledPageTitle>{title}</StyledPageTitle>
      <StyledPageContent>
        <Spin spinning={isLoading}>
          <ProductInfoCards data={dataSource} />
        </Spin>
      </StyledPageContent>
    </Page>
  )
}

export default AboutPage
